import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalLayout from '../components/layout/PortalLayout';
import { NavItem } from '../components/layout/PortalSidebar';
import CustomerDashboard from '../pages/customer/CustomerDashboard';
import CustomerProjects from '../pages/customer/CustomerProjects';
import CustomerInvoices from '../pages/customer/CustomerInvoices';
import { MOCK_NOTIFICATIONS } from '../mock';

const unread = MOCK_NOTIFICATIONS.filter(n => !n.read).length;

const navItems: NavItem[] = [
  { label: 'Dashboard', icon: 'LayoutDashboard', to: '/portal/dashboard' },
  { label: 'Service Requests', icon: 'FileQuestion', to: '/portal/requests' },
  { label: 'My Quotes', icon: 'FileText', to: '/portal/quotes' },
  { label: 'Appointments', icon: 'Calendar', to: '/portal/appointments' },
  { label: 'My Projects', icon: 'HardHat', to: '/portal/projects' },
  { label: 'Invoices', icon: 'Receipt', to: '/portal/invoices' },
  { label: 'Documents', icon: 'FolderOpen', to: '/portal/documents' },
  { label: 'Notifications', icon: 'Bell', to: '/portal/notifications', badge: unread },
  { label: 'My Profile', icon: 'User', to: '/portal/profile' },
];

const ComingSoon: React.FC<{ title: string }> = ({ title }) => (
  <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔧</div>
    <h2 style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem' }}>{title}</h2>
    <p style={{ color: 'var(--text-muted)' }}>This section is designed and ready for backend integration.</p>
  </div>
);

const CustomerRoutes: React.FC = () => (
  <PortalLayout navItems={navItems} title="Customer Portal" subtitle="Customer Portal">
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<CustomerDashboard />} />
      <Route path="requests" element={<ComingSoon title="Service Requests" />} />
      <Route path="quotes" element={<ComingSoon title="My Quotes" />} />
      <Route path="appointments" element={<ComingSoon title="Appointments" />} />
      <Route path="projects" element={<CustomerProjects />} />
      <Route path="invoices" element={<CustomerInvoices />} />
      <Route path="documents" element={<ComingSoon title="Documents" />} />
      <Route path="notifications" element={<ComingSoon title="Notifications" />} />
      <Route path="profile" element={<ComingSoon title="My Profile" />} />
    </Routes>
  </PortalLayout>
);

export default CustomerRoutes;
